module.exports = __webpack_public_path__ + "media/images/weather-icons/outline/thermometer-mercury-cold-73fe826b436fd3555da308217e62a566.svg";